import React from 'react';

function Panel({ title, sub, action, onAction, children, style, bodyStyle }) {
  return (
    <div className="panel" style={style}>
      {(title || action) && (
        <div className="panel-header">
          <div>
            {title && <div className="panel-title">{title}</div>}
            {sub && <div style={{fontSize:11,color:"var(--text-subtle)",marginTop:2}}>{sub}</div>}
          </div>
          {action && (
            <button className="panel-action" onClick={onAction} type="button">
              {action}
            </button>
          )}
        </div>
      )}
      <div className="panel-body" style={bodyStyle}>
        {children}
      </div>
    </div>
  );
}

export default Panel;
